module.exports = __webpack_public_path__ + "img/b2.15db178b.jpg";